(function () {
  'use strict';

  var initializedAttribute = 'data-dw-bis-early-initialized';

  function appIsPresent() {
    return Array.prototype.some.call(document.scripts, function (script) {
      return /backinstock\.useamp\.com\/widget\//.test(script.src || '');
    });
  }

  function initializeProduct(section) {
    if (!section || section.dataset.modal === 'true' || section.hasAttribute(initializedAttribute)) return;

    var root = section.querySelector('[data-dw-bis-early]');
    var colorGroup = section.querySelector('[data-native-color-option][data-index]');
    var sizeGroup = Array.prototype.find.call(section.querySelectorAll('.variant-input-wrap'), function (group) {
      return /size|sizing/i.test(group.getAttribute('name') || group.getAttribute('data-handle') || '');
    });
    var variantsJson = section.querySelector('[data-variant-json]');
    if (!root || !colorGroup || !sizeGroup || !variantsJson || !appIsPresent()) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent || '[]');
    } catch (error) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    section.setAttribute(initializedAttribute, 'true');

    var button = root.querySelector('[data-dw-bis-early-trigger]');
    var hint = root.querySelector('[data-dw-bis-early-hint]');
    var chooseSizeText = hint.textContent;
    var colorIndex = colorGroup.getAttribute('data-index');
    var sizeIndex = sizeGroup.getAttribute('data-index');
    var pendingColor = '';
    var pendingVariantId = '';
    var waitTimer = 0;

    function selected(group) {
      return group.querySelector('input[data-variant-input]:checked');
    }

    function state() {
      var colorInput = selected(colorGroup);
      var sizeInput = selected(sizeGroup);
      var color = colorInput ? String(colorInput.value) : '';
      var matching = color ? variants.filter(function (variant) {
        return String(variant[colorIndex]) === color;
      }) : [];
      return {
        color: color,
        size: sizeInput ? String(sizeInput.value) : '',
        allSoldOut: matching.length > 0 && matching.every(function (variant) {
          return variant.available === false;
        })
      };
    }

    function stopWaiting() {
      if (waitTimer) window.clearTimeout(waitTimer);
      waitTimer = 0;
      pendingColor = '';
      pendingVariantId = '';
    }

    function update() {
      var current = state();
      root.hidden = !(current.color && current.allSoldOut && !current.size);
      if (root.hidden) hint.hidden = true;
    }

    function waitForApp(attempt) {
      var current = state();
      if (!pendingVariantId || current.color !== pendingColor || !current.size) {
        stopWaiting();
        update();
        return;
      }

      var selectedVariant = new URLSearchParams(window.location.search).get('variant');
      var nativeButton = section.querySelector('#BIS_trigger');
      if (nativeButton && selectedVariant === pendingVariantId) {
        stopWaiting();
        window.setTimeout(function () {
          if (nativeButton.isConnected) nativeButton.click();
        }, 80);
        return;
      }

      if (attempt >= 40) {
        stopWaiting();
        root.hidden = false;
        hint.textContent = root.dataset.unavailable || chooseSizeText;
        hint.hidden = false;
        return;
      }
      waitTimer = window.setTimeout(function () {
        waitForApp(attempt + 1);
      }, 50);
    }

    button.addEventListener('click', function () {
      var current = state();
      if (!current.allSoldOut || !current.color) return;

      if (current.size) {
        var nativeButton = section.querySelector('#BIS_trigger');
        if (nativeButton) nativeButton.click();
        return;
      }

      pendingColor = current.color;
      hint.textContent = chooseSizeText;
      hint.hidden = false;
      var firstSize = sizeGroup.querySelector('input[data-variant-input]:not([disabled])');
      sizeGroup.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (firstSize) firstSize.focus({ preventScroll: true });
    });

    colorGroup.addEventListener('change', function () {
      stopWaiting();
      window.requestAnimationFrame(update);
    });

    sizeGroup.addEventListener('change', function () {
      var current = state();
      if (pendingColor && current.color === pendingColor && current.allSoldOut && current.size) {
        var variant = variants.find(function (item) {
          return String(item[colorIndex]) === current.color && String(item[sizeIndex]) === current.size;
        });
        if (variant && variant.available === false) {
          pendingVariantId = String(variant.id);
          root.hidden = true;
          waitForApp(0);
        }
      }
      window.requestAnimationFrame(update);
    });

    section.addEventListener('variantChange', function () {
      window.requestAnimationFrame(update);
    });
    update();
  }

  function initializeWithin(root) {
    if (root.matches && root.matches('[data-section-type="product"]')) initializeProduct(root);
    root.querySelectorAll('[data-section-type="product"]').forEach(initializeProduct);
  }

  function initialize() {
    initializeWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('load', initialize);
  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
}());
